import auth from '@/middleware/modules/auth'

const AnalyticsAccount = () => import(/* webpackChunkName: "_v-instagram_analytics" */ '@/views/instagram_analytics/Account.vue')

// Medias
const AnalyticsMedias = () => import(/* webpackChunkName: "_v-instagram_analyticsmedias" */ '@/views/instagram_analytics/Medias.vue')
const AnalyticsMediasIndex = () =>
  import(/* webpackChunkName: "_v-instagram_analyticsmedias" */ '@/views/instagram_analytics/Medias/Index.vue')
const AnalyticsMediasList = () =>
  import(/* webpackChunkName: "_v-instagram_analyticsmedias" */ '@/views/instagram_analytics/Medias/List.vue')

// Stories
const AnalyticsStories = () => import(/* webpackChunkName: "_v-instagram_analyticsstories" */ '@/views/instagram_analytics/Stories.vue')
const AnalyticsStoriesIndex = () =>
  import(/* webpackChunkName: "_v-instagram_analyticsstories" */ '@/views/instagram_analytics/Stories/Index.vue')
const AnalyticsStoriesList = () =>
  import(/* webpackChunkName: "_v-instagram_analyticsstories" */ '@/views/instagram_analytics/Stories/List.vue')
const AnalyticsComments = () => import(/* webpackChunkName: "_v-instagram_analytics" */ '@/views/instagram_analytics/Comments.vue')
const AnalyticsMentions = () => import(/* webpackChunkName: "_v-instagram_analytics" */ '@/views/instagram_analytics/Mentions.vue')

// Competitors
const AnalyticsCompetitors = () =>
  import(/* webpackChunkName: "_v-instagram_analyticscompetitors" */ '@/views/instagram_analytics/Competitors.vue')
const AnalyticsCompetitorsIndex = () =>
  import(/* webpackChunkName: "_v-instagram_analyticscompetitors" */ '@/views/instagram_analytics/competitors/Index.vue')
const AnalyticsCompetitorsAnalytics = () =>
  import(/* webpackChunkName: "_v-instagram_analyticscompetitors" */ '@/views/instagram_analytics/competitors/Analytics.vue')
const AnalyticsCompetitorsMedias = () =>
  import(/* webpackChunkName: "_v-instagram_analyticscompetitors" */ '@/views/instagram_analytics/competitors/Medias.vue')

// Hashtags
const AnalyticsHashtags = () => import(/* webpackChunkName: "_v-instagram_analyticshashtags" */ '@/views/instagram_analytics/Hashtags.vue')
const AnalyticsHashtagsIndex = () =>
  import(/* webpackChunkName: "_v-instagram_analyticshashtags" */ '@/views/instagram_analytics/hashtags/Index.vue')
const AnalyticsHashtagsAnalytics = () =>
  import(/* webpackChunkName: "_v-instagram_analyticshashtags" */ '@/views/instagram_analytics/hashtags/Analytics.vue')
const AnalyticsHashtagsMedias = () =>
  import(/* webpackChunkName: "_v-instagram_analyticshashtags" */ '@/views/instagram_analytics/hashtags/Medias.vue')

export default [
  {
    path: 'analytics/account',
    name: 'ig-analytics-account',
    component: AnalyticsAccount,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['iganalytics'],
    },
  },
  {
    path: 'analytics',
    name: 'iganalytics',
    component: AnalyticsAccount,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
    },
  },
  // {
  //   path: 'business-profile/:id(\\d+)/:tab?',
  //   name: 'ig-analytics-businessprofile',
  //   props: route => ({ tab: route.params.tab, id: route.params.id, querySearch: route.query.search }),
  //   component: BusinessProfile,
  //   meta: {
  //     layout: 'app-layout',
  //     middleware: [auth],
  //     breadcrumbs: ['iganalytics']
  //   }
  // },
  {
    path: 'analytics/medias',
    name: 'ig-analytics-medias',
    component: AnalyticsMedias,
    redirect: { name: 'ig-analytics-medias-index' },
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['iganalytics'],
    },
    children: [
      {
        path: '/',
        name: 'ig-analytics-medias-index',
        component: AnalyticsMediasIndex,
        meta: {
          layout: 'app-layout',
          tab: 'analytics',
          middleware: [auth],
        },
      },
      {
        path: 'content',
        name: 'ig-analytics-medias-list',
        component: AnalyticsMediasList,
        meta: {
          layout: 'app-layout',
          tab: 'list',
          middleware: [auth],
        },
      },
    ],
  },
  {
    path: 'analytics/stories',
    name: 'ig-analytics-stories',
    component: AnalyticsStories,
    redirect: { name: 'ig-analytics-stories-index' },
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['iganalytics'],
    },
    children: [
      {
        path: '/',
        name: 'ig-analytics-stories-index',
        component: AnalyticsStoriesIndex,
        meta: {
          layout: 'app-layout',
          tab: 'analytics',
          middleware: [auth],
        },
      },
      {
        path: 'content',
        name: 'ig-analytics-stories-list',
        component: AnalyticsStoriesList,
        meta: {
          layout: 'app-layout',
          tab: 'list',
          middleware: [auth],
        },
      },
    ],
  },
  {
    path: 'instagram-analytics/comments',
    name: 'ig-analytics-comments',
    component: AnalyticsComments,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['iganalytics'],
    },
  },
  // {
  //   path: 'instagram-analytics/competitors/:tab?',
  //   name: 'ig-analytics-competitors',
  //   component: AnalyticsCompetitors,
  //   props: route => ({ tab: route.params.tab, querySearch: route.query.search }),
  //   meta: {
  //     layout: 'app-layout',
  //     middleware: [auth],
  //     breadcrumbs: ['iganalytics']
  //   }
  // },
  {
    path: 'instagram-analytics/mentions',
    name: 'ig-analytics-mentions',
    component: AnalyticsMentions,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['iganalytics'],
    },
  },
  // {
  //   path: 'instagram-analytics/hashtags/:tab?/:hashtagid?',
  //   name: 'ig-analytics-hashtags',
  //   component: AnalyticsHashtags,
  //   props: route => ({ tab: route.params.tab, hashtagid: route.params.hashtagid, querySearch: route.query.search }),
  //   meta: {
  //     layout: 'app-layout',
  //     middleware: [auth],
  //     breadcrumbs: ['iganalytics']
  //   }
  // },

  // old competitors edit
  // {
  //   path: 'instagram-analytics/competitors/new',
  //   name: 'competitor-new',
  //   component: CompetitorEdit,
  //   meta: {
  //     layout: 'app-layout',
  //     middleware: [auth],
  //     breadcrumbs: ['iganalytics']
  //   }
  // },
  // {
  //   path: 'instagram-analytics/competitors/edit/:id',
  //   name: 'competitor-edit',
  //   component: CompetitorEdit,
  //   meta: {
  //     layout: 'app-layout',
  //     middleware: [auth],
  //     breadcrumbs: ['iganalytics']
  //   }
  // },
  // end old competitors edit
  // {
  //   path: 'instagram-analytics/hashtag/new',
  //   name: 'hashtag-new',
  //   component: HashtagEdit,
  //   meta: {
  //     layout: 'app-layout',
  //     middleware: [auth],
  //     breadcrumbs: ['iganalytics']
  //   }
  // },
  // {
  //   path: 'instagram-analytics/hashtag/edit/:id',
  //   name: 'hashtag-edit',
  //   component: HashtagEdit,
  //   meta: {
  //     layout: 'app-layout',
  //     middleware: [auth],
  //     breadcrumbs: ['iganalytics']
  //   }
  // },
  {
    path: 'instagram-analytics/competitors',
    name: 'ig-analytics-competitors',
    component: AnalyticsCompetitors,
    redirect: { name: 'ig-analytics-competitors-index' },
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['iganalytics'],
    },
    children: [
      {
        path: '/',
        name: 'ig-analytics-competitors-index',
        component: AnalyticsCompetitorsIndex,
        meta: {
          layout: 'app-layout',
          tab: 'index',
          middleware: [auth],
        },
      },
      {
        path: 'analytics',
        name: 'ig-analytics-competitors-analytics',
        component: AnalyticsCompetitorsAnalytics,
        meta: {
          layout: 'app-layout',
          tab: 'analytics',
          middleware: [auth],
        },
      },
      {
        path: 'medias',
        name: 'ig-analytics-competitors-medias',
        component: AnalyticsCompetitorsMedias,
        meta: {
          layout: 'app-layout',
          tab: 'medias',
          middleware: [auth],
        },
      },
    ],
  },
  {
    path: 'instagram-analytics/hashtags',
    name: 'ig-analytics-hashtags',
    component: AnalyticsHashtags,
    redirect: { name: 'ig-analytics-hashtags-index' },
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['iganalytics'],
    },
    children: [
      {
        path: '/',
        name: 'ig-analytics-hashtags-index',
        component: AnalyticsHashtagsIndex,
        meta: {
          layout: 'app-layout',
          tab: 'index',
          middleware: [auth],
        },
      },
      {
        path: 'analytics',
        name: 'ig-analytics-hashtags-analytics',
        component: AnalyticsHashtagsAnalytics,
        meta: {
          layout: 'app-layout',
          tab: 'analytics',
          middleware: [auth],
        },
      },
      {
        path: 'medias',
        name: 'ig-analytics-hashtags-medias',
        component: AnalyticsHashtagsMedias,
        meta: {
          layout: 'app-layout',
          tab: 'medias',
          middleware: [auth],
        },
      },
    ],
  },
]
